import { FiChevronDown } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { useEffect, useState } from 'react';
import books from '@/assets/images/icons/books.svg';
import { AiOutlineTrophy } from 'react-icons/ai';
import { Tooltip } from 'react-tooltip';

export default function StudentsTable({ data = [], filters, selectedGre, selectedSchool, setSelectedGre, setSelectedSchool, kpis: detailKpis, sortConfig, onSort, getColor, getBadgeClass }) {
  const [filteredData, setFilteredData] = useState(data);

  const kpis = [
    {
      id: 1,
      title: 'Matemática e suas Tecnologias',
      value: detailKpis?.matematica?.label || '--',
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 2,
      title: 'Ciências Humanas e Sociais Aplicadas',
      value: detailKpis?.ciencias_humanas?.label || '--',
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 3,
      title: 'Ciências da Natureza',
      value: detailKpis?.ciencias_natureza?.label || '--',
      variation: 'report-kpi-card--analytics'
    },
    {
      id: 4,
      title: 'Linguagens e suas Tecnologias',
      value: detailKpis?.linguagens?.label || '--',
      variation: 'report-kpi-card--analytics'
    }
  ];

  useEffect(() => {
    if (filters.values['searchTerm'].length > 0) {
      const filtered = data?.filter(item => item?.name?.toLowerCase().includes(filters.values['searchTerm'].toLowerCase()) || item?.email?.toLowerCase().includes(filters.values['searchTerm'].toLowerCase()));
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [filters.values['searchTerm'], data]);

  return (
    <div className="round-dg-wrapper">
      <div className="mb-6 flex gap-2 border-b border-neutral-lightest pb-3">
        <span className="text-neutral-light">Aulas</span>
        <span
          onClick={() => {
            setSelectedGre(null);
            setSelectedSchool(null);
          }}
          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
        >
          <FiChevronDown
            style={{ transform: 'rotate(90deg)' }}
            className="card__icon"
          />
        </span>
        <span className="font-semibold text-primary-dark">{selectedGre?.['regional_name']}</span>
        <span
          onClick={() => {
            setSelectedSchool(null);
          }}
          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
        >
          <FiChevronDown
            style={{ transform: 'rotate(90deg)' }}
            className="card__icon"
          />
        </span>
        <span className="font-semibold text-primary-dark">{selectedSchool?.['institution_name']}</span>
      </div>
      <div className="overflow-auto rounded-2xl bg-neutral-bright p-4">
        <div className="report-kpi-card-wrapper mb-6">
          {kpis.map(kpi => (
            <div
              className={`report-kpi-card ${kpi.variation}`}
              key={kpi.id}
            >
              <h3 className="report-kpi-card__title font-semibold text-primary-dark">{kpi.title}</h3>
              <p
                className="report-kpi-card__value"
                title={kpi?.value}
              >
                {kpi?.value}
              </p>
            </div>
          ))}
        </div>

        <div className="report-widget__filter mb-2">
          <input
            className="report-form__control report-form__control--md"
            aria-label="Pesquisar"
            placeholder="Pesquisar"
            type="search"
            name="search"
            id="search"
            onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
            disabled={data?.length === 0 && filters.values.searchTerm === ''}
          />
        </div>

        <div className="round-dg-wrapper overflow-visible">
          {filteredData?.length === 0 ? (
            <EmptyState
              title="Nenhum dado disponível"
              type="data"
              text="Não há dados a serem exibidos."
              className="my-10"
            />
          ) : (
            <>
              <table className="round-dg round-dg--light min-w-[564px]">
                <thead className="round-dg__header">
                  <tr className="round-dg__row">
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-12">Posição</th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-9"></th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-64">Nome e e-mail</th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-[150px]">
                      Matemática
                      <span
                        onClick={() => onSort('math')}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                      >
                        <FiChevronDown
                          style={{ transform: sortConfig.field === 'math' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-[150px]">
                      Ciências Humanas
                      <span
                        onClick={() => onSort('humanities')}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                      >
                        <FiChevronDown
                          style={{ transform: sortConfig.field === 'humanities' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-40">
                      Ciências da Natureza
                      <span
                        onClick={() => onSort('natural-sciences')}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                      >
                        <FiChevronDown
                          style={{ transform: sortConfig.field === 'natural-sciences' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-[160px]">
                      <div className="flex w-full items-center">
                        <span
                          className="flex-1 truncate text-left"
                          title="Linguagens e suas Tecnologias"
                        >
                          Linguagens e suas Tecnologias
                        </span>
                        <span
                          onClick={() => onSort('technology')}
                          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1 shrink-0"
                        >
                          <FiChevronDown
                            style={{ transform: sortConfig.field === 'technology' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                            className="card__icon"
                          />
                        </span>
                      </div>
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm w-36">
                      <div className="flex w-full items-center">
                        <span
                          className="flex-1 truncate text-left"
                          title="Linguagens e suas Tecnologias"
                        >
                          Status da intervenção
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody className="round-dg__body">
                  {filteredData?.map((item, i) => (
                    <tr
                      key={item.id}
                      className="round-dg__row relative"
                    >
                      <td className="round-dg__cell round-dg__cell--sm u-text-right">{i + 1 < 10 ? `0${i + 1}` : i + 1}</td>
                      <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                        {i === 0 && <AiOutlineTrophy className="card__icon card__icon--golden mr-3" />}
                        {i === 1 && <AiOutlineTrophy className="card__icon card__icon--silver mr-3" />}
                        {i === 2 && <AiOutlineTrophy className="card__icon card__icon--bronze mr-3" />}
                      </th>
                      {/* NOME */}
                      <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                        {item?.overall?.label === 'Preventivo' && (
                          <div className="absolute -left-3 top-1/2 z-10 -translate-y-1/2 rounded-full border border-[#61F3F3] bg-[#00B8D914] p-1.5 shadow-md">
                            <img
                              src={books}
                              alt="Preventivo"
                              className="h-4 w-4"
                              data-tooltip-id={`tooltip-preventivo-${item.id}`}
                            />
                            <Tooltip
                              id={`tooltip-preventivo-${item.id}`}
                              className="tooltip border-neutral-d"
                              place="top-start"
                              opacity={1}
                              border="1px solid var(--color-neutral-lightest)"
                              style={{ backgroundColor: '#F1F5FA', width: '200px', color: 'var(--color-neutral-darker)' }}
                            >
                              Esse estudante pode monitorar outros estudantes
                            </Tooltip>
                          </div>
                        )}
                        <p className="font-semibold text-primary-dark">{item?.name}</p>
                        <p className="text-neutral">{item?.email}</p>
                      </th>

                      {/* RESTANTE DAS COLUNAS */}
                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['matematica']?.percentage)}`}>
                        {item?.['matematica']?.percentage !== null && item?.['matematica']?.label ? `${item?.['matematica']?.label}% (${item?.['matematica']?.percentage?.toFixed(2)}%)` : '--'}
                      </td>

                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_humanas']?.percentage)}`}>
                        {item?.['ciencias_humanas']?.percentage !== null && item?.['ciencias_humanas']?.label ? `${item?.['ciencias_humanas']?.label}% (${item?.['ciencias_humanas']?.percentage?.toFixed(2)}%)` : '--'}
                      </td>

                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_natureza']?.percentage)}`}>
                        {item?.['ciencias_natureza']?.percentage !== null && item?.['ciencias_natureza']?.label ? `${item?.['ciencias_natureza']?.label}% (${item?.['ciencias_natureza']?.percentage?.toFixed(2)}%)` : '--'}
                      </td>

                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['linguagens']?.percentage)}`}>
                        {item?.['linguagens']?.percentage !== null && item?.['linguagens']?.label ? `${item?.['linguagens']?.label}% (${item?.['linguagens']?.percentage?.toFixed(2)}%)` : '--'}
                      </td>

                      <td className="round-dg__cell round-dg__cell--sm">
                        <span className={`badge badge--tiny ${getBadgeClass(item?.overall?.percentage)}`}>{item?.overall?.label}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
